import React from 'react';
import PropTypes from 'prop-types';
import FormError from '../partials/FormError';
import __ from '../../helpers/translation';

const propTypes = {
  callback: PropTypes.func.isRequired,
  data: PropTypes.object,
  modal: PropTypes.object
};

function InspectionStartModal(props) {
    let data = props.data;
    let callback = props.callback;
    let modal = props.modal;

    return (

        <div className="modal fade" id="modalInspectionStart" tabIndex="-1" role="dialog" aria-labelledby="modalInspectionStart" aria-hidden="true">
            <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div className="modal-content p-3 p-sm-5">
                    <div className="modal-header">
                        <h1 className="modal-title fw-600" id="exampleModalLongTitle">{ __('app.inspections.start_inspection_title') }</h1>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {modal && modal.errors && 
                            (
                                <FormError>{modal.errors}</FormError>
                            )
                        }
                        <div className="d-block md-data">
                            <span>{ __('app.inspections.title_company') }</span>
                            <strong>{ data.selectedCompany ? data.selectedCompany.name : '' }</strong>
                        </div>
                        <div className="d-block md-data">
                            <span>{ __('app.inspections.title_location') }</span>
                            <strong>{ data.selectedLocation ? data.selectedLocation.name : '' }</strong>
                        </div>
                        <div className="d-block md-data">
                            <span>{ __('app.inspections.title_sublocation') }</span>
                            <strong>{ data.selectedSublocation ? data.selectedSublocation.name : '' }</strong>
                        </div>
                        <div className="d-block md-data">
                            <span>{ __('app.inspections.title_removal') }</span>
                            <strong>{ data.selectedRemoval ? data.selectedRemoval.name : '' }</strong>
                        </div>
                        <button type="button" 
                            className="btn btn-success d-block w-100 mt-5" 
                            onClick={(e) => callback(e)}
                            {... modal && modal.loading && {'disabled': true}}>
                            { __('app.inspections.start_inspection_button') }
                            {modal && modal.loading && (
                                <i className="far fa-circle-notch fa-spin ml-3"></i>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>

    )
}

InspectionStartModal.propTypes = propTypes;

export default InspectionStartModal;